import React from "react";
import { PortalPage, PortalPageHead, PortalAlert } from "../portal-ui";

export function EmberAnalyticsShell({
  eyebrow,
  title,
  lede,
  actions,
  filters,
  error,
  notice,
  children,
}) {
  return (
    <PortalPage className="ember-analytics">
      <div className="ember-analytics__head">
        <PortalPageHead eyebrow={eyebrow} title={title} lede={lede} />
        {actions ? <div className="ember-analytics__actions">{actions}</div> : null}
      </div>
      {filters ? <div className="ember-analytics__filters">{filters}</div> : null}
      {error ? <PortalAlert variant="error">{error}</PortalAlert> : null}
      {notice ? <PortalAlert variant="success">{notice}</PortalAlert> : null}
      {children}
    </PortalPage>
  );
}
